/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileNwd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M14.414 2H4v20h16v-3h-2v1H6V4h7v5h5v1h2V7.586zm2.172 5H15V5.414z" />
        <path d="M7.295 17v-4.87h.965l2.103 3.168V12.13h1.032V17h-.964l-2.104-3.176V17zm5.768 0-1.079-4.87h1.059l.69 3.282.871-3.015h.864l.912 2.975.683-3.243h1.032L17.016 17h-1.005l-.998-3.276L14.068 17zm5.623-4.87V17h1.635c.8 0 1.4-.205 1.802-.616.407-.416.61-1.021.61-1.816 0-.804-.203-1.412-.61-1.822-.406-.411-1.007-.617-1.802-.617zm1.045.85h.577c.455 0 .793.13 1.011.389.22.259.329.658.329 1.199s-.112.94-.335 1.2c-.22.254-.554.381-1.005.381h-.577z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileNwd as FileNwd };
